// extracted by mini-css-extract-plugin
export default {"mainContainer":"mainContainer___wkq3d","wasteAccompanyingDocumentContainer":"wasteAccompanyingDocumentContainer___Y4c4e"};